module.exports = __webpack_public_path__ + "media/app/components/ChatSupport/Mascot.a4e53e17.svg";